(function ($, Global) {
	var VeillesComponent = function (model) {
		this.model = model;
	}

    VeillesComponent.prototype.initEvents = function () {
        this.publishers();
	}

	VeillesComponent.prototype.publishers = function () {
        var debounce = null;
        $(document).on('click', '.list-keywords li a', function (e) {
            e.preventDefault();
            var $this = $(this);

            clearTimeout(debounce);
            debounce = setTimeout(function () {
                var data = {};
                var val = $this.data('item').trim();
                var alreadyNotificationMessage = $('#alreadyNotification').text().trim();
                if ($this[0].hasAttribute('data-toggle') || $this[0].hasAttribute('onclick')) return;

                data.termesRecherches = val;
                data.isGeneric = true;

                $.Topic('veille-new').publish(data, function () {
                    $this.find('.keyword-block').addClass('subscribed').append("<span class=\"tip-text\">" + alreadyNotificationMessage + "</span>");
                });
            }, 600)
        });

		$(document).on('click', '#btnShowKeywords', function (e) {
			e.preventDefault();

            var $this = $(this);
            var $parent = $this.parent().find('.list-keywords');
            var $keywordItemsHidden = $parent.find('li.d-none');
            $keywordItemsHidden.removeClass('d-none').addClass('d-block');

            $this.addClass('d-none');
            $this.closest('.sidenav-keywords').find('#btnHideKeywords').removeClass('d-none');
        });
        $(document).on('click', '#btnHideKeywords', function (e) {
            e.preventDefault();

            var $this = $(this);
            var $parent = $this.parent().find('.list-keywords');
            var $keywordItemsToHidden = $parent.find('li.d-block');
            $keywordItemsToHidden.removeClass('d-block').addClass('d-none');

            $this.addClass('d-none');
            $this.closest('.sidenav-keywords').find('#btnShowKeywords').removeClass('d-none');
        });
	}

	Global.VeillesComponent = VeillesComponent;
}(jQuery, window));